
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.723 18.951c-1.396 7.17-6.175 9.65-12.295 9.65h-.944a1.519 1.519 0 00-1.495 1.277l-.075.396-1.19 7.536-.064.32a1.515 1.515 0 01-1.495 1.278H8.891a.91.91 0 01-.896-1.051l.515-3.268 1.82-11.545a1.724 1.724 0 011.702-1.448h3.57c6.972 0 12.433-2.831 14.027-11.025.048-.242.088-.476.123-.706a5.978 5.978 0 011.726 1.328c1.526 1.785 1.828 4.264 1.245 7.258z","fill":"#609FCB"}}),_c('path',{attrs:{"d":"M29.736 10.373c-.036.23-.075.464-.123.706-1.586 8.193-7.055 11.025-14.028 11.025h-3.57a1.725 1.725 0 00-1.7 1.448l.055-.357 2.019-12.783a1.52 1.52 0 011.495-1.28h9.487c1.047-.007 2.093.07 3.129.23.273.043.54.094.793.15.254.055.512.123.754.194l.36.111c.459.147.903.332 1.329.556z","fill":"#8FB6D6"}}),_c('path',{attrs:{"d":"M29.736 10.373a8.335 8.335 0 00-1.309-.555l-.36-.111a12.249 12.249 0 00-1.547-.346 19.75 19.75 0 00-3.15-.245H13.9a1.52 1.52 0 00-1.495 1.28L10.386 23.18l-.055.357-1.82 11.545H1.037a1.04 1.04 0 01-1.027-1.19l5.04-31.954A1.737 1.737 0 016.762.474h12.104c4.034 0 7.219.825 9.055 2.744l.174.19c.076.088.155.175.226.266.072.091.143.179.21.27.136.182.258.365.373.551a6.474 6.474 0 01.445.86c.083.183.158.397.226.604a9.52 9.52 0 01.162 4.414z","fill":"#fff"}})])
          )
        }
      }
    